<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="container">
        <div class="footer-grid">
          <!-- 公司信息 -->
          <div class="footer-section company-info">
            <div class="footer-logo">
              <img src="../assets/img/index/ranyuanicon.png" alt="燃源科技" class="logo-img" />
              <div class="logo-text">
                <h3 class="company-name">燃源科技</h3>
                <p class="company-slogan">RANYUAN TECH</p>
              </div>
            </div>
            <p class="company-desc">
              专业的互联网解决方案提供商，致力于为客户提供高质量的软件开发服务，
              涵盖APP、WEB网站、企业门户、小程序、管理系统等多个领域。
            </p>
            <div class="social-links">
              <div class="social-item" title="微信">
                <img :src="weixinIcon" alt="微信" class="social-icon" />
                <div class="qr-code-container">
                  <img :src="weixinQR" alt="微信二维码" class="qr-code" />
                  <span class="qr-tip">扫码添加微信</span>
                </div>
              </div>
              <div class="social-item" title="小程序">
                <img :src="xiaochengxuIcon" alt="小程序" class="social-icon" />
                <div class="qr-code-container">
                  <img :src="xiaochengxuQR" alt="小程序二维码" class="qr-code" />
                  <span class="qr-tip">扫码使用小程序</span>
                </div>
              </div>
              <div class="social-item" title="QQ">
                <img :src="qqIcon" alt="QQ" class="social-icon" />
                <div class="qr-code-container">
                  <img :src="qqQR" alt="QQ二维码" class="qr-code" />
                  <span class="qr-tip">扫码添加QQ</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 服务项目 -->
          <div class="footer-section services">
            <h4 class="footer-title">服务项目</h4>
            <ul class="footer-links">
              <li><a href="/product" class="footer-link">网站开发</a></li>
              <li><a href="/product" class="footer-link">APP开发</a></li>
              <li><a href="/product" class="footer-link">小程序开发</a></li>
              <li><a href="/product" class="footer-link">系统开发</a></li>
              <li><a href="/product" class="footer-link">UI设计</a></li>
            </ul>
          </div>

          <!-- 关于我们 -->
          <div class="footer-section about">
            <h4 class="footer-title">关于我们</h4>
            <ul class="footer-links">
              <li><a href="/about" class="footer-link">公司简介</a></li>
              <li><a href="/about" class="footer-link">团队介绍</a></li>
              <li><a href="/about" class="footer-link">发展历程</a></li>
              <li><a href="/about" class="footer-link">企业文化</a></li>
              <li><a href="/about" class="footer-link">联系我们</a></li>
            </ul>
          </div>

          <!-- 联系方式 -->
          <div class="footer-section contact">
            <h4 class="footer-title">联系方式</h4>
            <div class="contact-info">
              <div class="contact-item">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>135-2621-7357</span>
              </div>
              <div class="contact-item">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <polyline points="22,6 12,13 2,6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>rysoft@139.com</span>
              </div>
              <div class="contact-item">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <circle cx="12" cy="10" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>河南省郑州市郑东新区永和宇宙星</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 底部信息 -->
        <div class="footer-bottom">
          <div class="footer-bottom-content">
            <div class="copyright">
              <p>&copy; 2024 燃源科技. All rights reserved.</p>
              <!-- 网站备案信息 -->
              <p class="beian-info">
                <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">豫ICP备2021012534号-2</a> |
                <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41910902000131" target="_blank" rel="noopener noreferrer">豫公网安备 41910902000131号</a>
              </p>
            </div>
            <div class="footer-bottom-links">
              <router-link to="/privacy" class="footer-bottom-link">隐私政策</router-link>
              <router-link to="/agreement" class="footer-bottom-link">服务条款</router-link>
              <a href="#" class="footer-bottom-link">网站地图</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 背景装饰 -->
    <div class="footer-bg">
      <div class="bg-pattern"></div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      weixinIcon: require('@/assets/img/focus/weixin.svg'),
      weixinQR: require('@/assets/img/focus/wx.jpg'),
      xiaochengxuIcon: require('@/assets/img/focus/wxxcx.jpg'),
      xiaochengxuQR: require('@/assets/img/focus/little_code.jpg'),
      qqIcon: require('@/assets/img/focus/qq.png'), // 使用新创建的QQ图标
      qqQR: require('@/assets/img/focus/qq_code.jpg') // 暂时使用微信二维码作为QQ二维码
    }
  }
}
</script>

<style lang="less" scoped>
.footer {
  position: relative;
  background: var(--bg-secondary);
  color: var(--text-primary);
  overflow: hidden;

  .footer-content {
    position: relative;
    z-index: 2;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 24px;
  }

  .footer-grid {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1.5fr;
    gap: 48px;
    padding: 80px 0 40px;
  }

  .footer-section {
    .footer-title {
      font-size: var(--font-size-lg);
      font-weight: 600;
      margin-bottom: 24px;
      color: var(--text-primary);
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: -8px;
        left: 0;
        width: 30px;
        height: 2px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border-radius: 1px;
      }
    }
  }

  // 公司信息
  .company-info {
    .footer-logo {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 24px;

      .logo-img {
        width: 48px;
        height: 48px;
        border-radius: 12px;
      }

      .logo-text {
        .company-name {
          font-size: var(--font-size-xl);
          font-weight: 700;
          margin: 0;
          background: linear-gradient(135deg, #ffffff 0%, #b2bac2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .company-slogan {
          font-size: var(--font-size-xs);
          color: var(--text-secondary);
          margin: 0;
          letter-spacing: 1px;
        }
      }
    }

    .company-desc {
      color: var(--text-secondary);
      line-height: 1.6;
      margin-bottom: 32px;
    }

    .social-links {
      display: flex;
      gap: 16px;

      .social-item {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        transition: transform 0.3s ease;

        &:hover {
          transform: translateY(-5px);
        }

        .social-icon {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
          border: 1px solid rgba(255, 255, 255, 0.1);
          overflow: hidden;

          img {
            width: 20px;
            height: 20px;
            opacity: 0.7;
            transition: all 0.3s ease;
            border-radius: 50%;
            object-fit: cover;
          }

          // 小程序图标特殊样式
          &:nth-child(2) img {
            width: 24px;
            height: 24px;
            border-radius: 6px;
          }

          &:hover {
            background: rgba(102, 126, 234, 0.2);
            border-color: rgba(102, 126, 234, 0.3);
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);

            img {
              opacity: 1;
              transform: scale(1.1);
            }
          }
        }

        .qr-code-container {
          position: absolute;
          bottom: 50px;
          left: 50%;
          transform: translateX(-50%) translateY(10px);
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
          opacity: 0;
          visibility: hidden;
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          z-index: 1000;
          width: 140px;
          padding: 16px;
          text-align: center;
          border: 1px solid rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(10px);

          &::before {
            content: '';
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            width: 0;
            height: 0;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-top: 8px solid #fff;
          }

          .qr-code {
            width: 100px;
            height: 100px;
            margin-bottom: 12px;
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            transition: transform 0.3s ease;
          }

          .qr-tip {
            font-size: 12px;
            color: #666;
            line-height: 1.4;
            font-weight: 500;
            display: block;
          }
        }

        &:hover .qr-code-container {
          opacity: 1;
          visibility: visible;
          transform: translateX(-50%) translateY(0);
        }

        &:hover .qr-code-container .qr-code {
          transform: scale(1.05);
        }
      }
    }
  }

  // 链接列表
  .footer-links {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      margin-bottom: 12px;
    }

    .footer-link {
      color: var(--text-secondary);
      text-decoration: none;
      transition: all 0.3s ease;
      position: relative;
      padding-left: 0;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        width: 0;
        height: 2px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        transition: width 0.3s ease;
        transform: translateY(-50%);
      }

      &:hover {
        color: var(--text-primary);
        padding-left: 16px;

        &::before {
          width: 12px;
        }
      }
    }
  }

  // 联系方式
  .contact-info {
    .contact-item {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 16px;
      color: var(--text-secondary);
      transition: color 0.3s ease;

      svg {
        color: #667eea;
        flex-shrink: 0;
      }

      span {
        line-height: 1.4;
      }

      &:hover {
        color: var(--text-primary);
      }
    }
  }

  // 底部信息
  .footer-bottom {
    border-top: 1px solid var(--border-color);
    padding: 24px 0;

    .footer-bottom-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 16px;
    }

    .copyright {
      p {
        color: var(--text-secondary);
        margin: 0;
        font-size: var(--font-size-sm);
      }
      
      .beian-info {
        margin-top: 8px;
        font-size: var(--font-size-xs);
        
        a {
          color: var(--text-secondary);
          text-decoration: none;
          transition: color 0.3s ease;
          
          &:hover {
            color: var(--text-primary);
            text-decoration: underline;
          }
        }
      }
    }

    .footer-bottom-links {
      display: flex;
      gap: 24px;

      .footer-bottom-link {
        color: var(--text-secondary);
        text-decoration: none;
        font-size: var(--font-size-sm);
        transition: color 0.3s ease;

        &:hover {
          color: var(--text-primary);
        }
      }
    }
  }

  // 背景装饰
  .footer-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;

    .bg-pattern {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: 
        radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.1) 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.1) 0%, transparent 50%),
        radial-gradient(circle at 40% 40%, rgba(102, 126, 234, 0.05) 0%, transparent 50%);
      opacity: 0.6;
    }
  }
}

@media (max-width: 1024px) {
  .footer {
    .footer-grid {
      grid-template-columns: 1fr 1fr;
      gap: 40px;
    }
  }
}

@media (max-width: 768px) {
  .footer {
    .container {
      padding: 0 16px;
    }

    .footer-grid {
      grid-template-columns: 1fr;
      gap: 32px;
      padding: 60px 0 32px;
    }

    // 手机模式下所有内容居中
    .footer-section {
      text-align: center;

      .footer-title {
        &::after {
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }

    // 公司信息居中
    .company-info {
      .footer-logo {
        justify-content: center;
      }

      .social-links {
        justify-content: center;

        .social-item {
          .qr-code-container {
            left: 50%;
            transform: translateX(-50%) translateY(10px);
            
            &:hover {
              transform: translateX(-50%) translateY(0);
            }
          }
        }
      }
    }

    // 链接列表居中
    .footer-links {
      li {
        text-align: center;
      }

      .footer-link {
        padding-left: 0;

        &::before {
          display: none;
        }

        &:hover {
          padding-left: 0;
        }
      }
    }

    // 联系方式居中
    .contact-info {
      .contact-item {
        justify-content: center;
      }
    }

    .footer-bottom {
      .footer-bottom-content {
        flex-direction: column;
        text-align: center;
      }

      .footer-bottom-links {
        justify-content: center;
      }
    }
  }
}
</style>
</file>